import Axios from 'axios';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
  extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function(d, b) { d.__proto__ = b; }) ||
        function(d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
  return extendStatics(d, b);
};

function __extends(d, b) {
  if (typeof b !== 'function' && b !== null) { throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null'); }
  extendStatics(d, b);
  function __() { this.constructor = d; }
  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) { return value instanceof P ? value : new P(function(resolve) { resolve(value); }); }
  return new (P || (P = Promise))(function(resolve, reject) {
    function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
    function rejected(value) { try { step(generator['throw'](value)); } catch (e) { reject(e); } }
    function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}

function __generator(thisArg, body) {
  var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }; var f; var y; var t; var g;
  return g = { next: verb(0), 'throw': verb(1), 'return': verb(2) }, typeof Symbol === 'function' && (g[Symbol.iterator] = function() { return this; }), g;
  function verb(n) { return function(v) { return step([n, v]); }; }
  function step(op) {
    if (f) throw new TypeError('Generator is already executing.');
    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y['return'] : op[0] ? y['throw'] || ((t = y['return']) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];
        switch (op[0]) {
          case 0: case 1: t = op; break;
          case 4: _.label++; return { value: op[1], done: false };
          case 5: _.label++; y = op[1]; op = [0]; continue;
          case 7: op = _.ops.pop(); _.trys.pop(); continue;
          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
            if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
            if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
            if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
            if (t[2]) _.ops.pop();
            _.trys.pop(); continue;
        }
        op = body.call(thisArg, _);
      } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
    }
    if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
  }
}

var http = Axios.create({
  timeout: 40000,
  withCredentials: true,
  headers: { 'Content-Type': 'application/json' }
});
// 响应拦截器
http.interceptors.request.use(function(res) {
  res.headers;
  // console.log(headers)
  return res;
}, function(error) {
  return Promise.reject(error);
});

// 获取网络类型
function getNetworkType() {
  /* wired 有线
      bluetooth,
      wifi,
      2g,3g,4g,5g...,
      unkown
    */
  var ua = navigator.userAgent;
  var ut = navigator.connection;
  var utt = ut ? ut.type ? ut.type.toLowerCase() : null : null;
  if (utt) {
    switch (utt) { // bluetooth,
      case 'cellular':
      case 'wimax':
        utt = ut ? ut.effectiveType ? ut.effectiveType.toLowerCase() : null : null;
        break;
      case 'wifi':
        break;
      case 'ethernet':
        utt = 'wired';
      case 'none':
      case 'other':
      case 'unknown':
        utt = null;
    }
  }
  var networkStr = utt || (ua.match(/NetType\/\w+/) ? ua.match(/NetType\/\w+/)[0] : '');
  networkStr = networkStr.toLowerCase().replace('nettype/', '');
  return networkStr ? networkStr === '3gnet' ? '3g' : networkStr : 'unknown';
}
function transformData(data) {
  var info = {};
  var keyMap = {
    title: 'tit',
    url: 'ul',
    urlPath: 'up',
    userId: 'uid',
    time: 'te',
    sessinodId: 'si',
    deviceId: 'di',
    networkType: 'nt',
    libType: 'lb',
    libVersion: 'lbv',
    webType: 'wt',
    elementId: 'ei',
    elementName: 'en',
    elementContent: 'ec',
    elementTargetUrl: 'etu',
    referrerHost: 'rh',
    referrerUrl: 'rr',
    eventDuration: 'ed'
  };
  for (var key in keyMap) {
    info[keyMap[key]] = data[key];
  }
  return info;
}

var Basic = /** @class */ (function() {
  function Basic(appId, sendUrl, config) {
    this.basicPage = {
      title: '',
      url: '',
      urlPath: '',
      userId: '0',
      time: 0,
      sessinodId: '',
      deviceId: '',
      networkType: '',
      libType: 'js',
      libVersion: '1.0.0'
    };
    this.appId = appId;
    this.sendUrl = sendUrl;
    this.config = config;
  }
  /* 上报数据 */
  Basic.prototype.send = function(data) {
    var _a, _b, _c;
    return __awaiter(this, void 0, void 0, function() {
      var info, res;
      return __generator(this, function(_d) {
        switch (_d.label) {
          case 0:
            info = Object.assign(this.basicPage, {
              appId: this.appId,
              userId: window.localStorage.getItem((_a = this.config) === null || _a === void 0 ? void 0 : _a.userIdKey) || window.sessionStorage.getItem((_b = this.config) === null || _b === void 0 ? void 0 : _b.userIdKey) || '0',
              sessinodId: window.localStorage.getItem((_c = this.config) === null || _c === void 0 ? void 0 : _c.tokenKey) || '0',
              networkType: getNetworkType(),
              time: new Date().getTime(),
              title: document.title,
              url: window.location.href,
              urlPath: window.location.hash
            }, data);
            return [4 /* yield*/, http.post(''.concat(this.sendUrl, '/log_web'), transformData(info))];
          case 1:
            res = _d.sent();
            if (res.status === 200) {
              console.log('上报成功');
            } else {
              console.error('上报失败');
            }
            return [2];
        }
      });
    });
  };
  return Basic;
}());

var Event = /** @class */ (function(_super) {
  __extends(Event, _super);
  function Event(appId, sendUrl, config) {
    var _this = _super.call(this, appId, sendUrl, config) || this;
    _this.eventPage = {
      webType: 2,
      elementId: '',
      elementName: '',
      elementContent: '',
      elementTargetUrl: ''
    };
    _this.watchClick();
    _this.watchScroll();
    return _this;
  }
  /* 监听页面所有点击事件 */
  Event.prototype.watchClick = function() {
    var _this = this;
    window.addEventListener('click', function(e) {
      // console.log(e)
      var target = e.target && e.target.nodeType === 3 ? e.target.parentNode : e.target;
      var _a = target; var value = _a.value; var hash = _a.hash; var dataset = _a.dataset; var nodeName = _a.nodeName; var innerText = _a.innerText;
      if (_this.isBindClick(target)) {
        var index = innerText.indexOf('\n') < 0
          ? innerText.length : innerText.indexOf('\n');
        Object.assign(_this.eventPage, {
          elementId: (dataset === null || dataset === void 0 ? void 0 : dataset.id) || '',
          elementName: (dataset === null || dataset === void 0 ? void 0 : dataset.name) || '',
          elementContent: nodeName == 'INPUT' ? value : innerText.substring(0, index),
          elementTargetUrl: nodeName == 'A' ? hash : ''
        });
        _this.send(_this.eventPage);
      }
    }, false);
  };
  // 判断当前点击元素是否绑定点击事件
  Event.prototype.isBindClick = function(tagert) {
    if (tagert.nodeName === 'HTML') { return false; }
    return tagert.nodeName === 'A' ||
            typeof tagert.onclick === 'function' ||
            this.isVNode(tagert);
  };
  /*
       此方法针对 vue @click绑定的事件，
       @click原理是通过 事件委托 方式进行事件绑定，所以无法通过 onclick 是否为 function 进行判断
       利用类似冒泡机制向上查找绑定了事件的目标元素
    */
  Event.prototype.isVNode = function(tagert) {
    var _a;
    if (!document.getElementById('app')) { return false; }
    var flag = false;
    var node = tagert;
    while (node != document.getElementById('app')) {
      if (node === null || node === void 0 ? void 0 : node.__vue__) {
        flag = (_a = node === null || node === void 0 ? void 0 : node.__vue__) === null || _a === void 0 ? void 0 : _a.$listeners.hasOwnProperty('click');
        break;
      }
      node = node.parentNode;
    }
    return flag;
  };
  /* 监听页面视区停留 （运营说暂时不做）*/
  Event.prototype.watchScroll = function() {
    // const debounce = (wait: number) => {
    //     let timer: NodeJS.Timeout;
    //     const _this = this;
    //     const startTime = getTimestamp();
    //     return function () {
    //         if (timer) clearTimeout(timer);
    //         timer = setTimeout(() => {
    //             // _this.send({
    //             //     wt: 3,
    //             //     ed: getTimestamp() - startTime //停留时长 当前事件触发时间 - 上一次事件触发时间
    //             // })
    //         }, wait)
    //     }
    // }
    // // 初始化时间
    // const initTime = function () {
    //     const delay_time = new Date().getTime() - this.currentTime;
    //     if (delay_time > 4000) {
    //         const event_duration = Math.min(4000, delay_time)
    //         // this.send({
    //         //     wt: 3,
    //         // })
    //     }
    //     this.currentTime = delay_time;
    // }
    // window.addEventListener('scroll', (e) => {
    //     console.log(e)
    // })
  };
  return Event;
}(Basic));

var Router = /** @class */ (function(_super) {
  __extends(Router, _super);
  function Router(appId, router, sendUrl, config) {
    var _this = _super.call(this, appId, sendUrl, config) || this;
    _this.routerPage = {
      webType: 1,
      referrerHost: '',
      referrerUrl: '',
      eventDuration: 0
    };
    _this._router = router;
    _this.currentTime = new Date().getTime();
    _this.afterEach();
    return _this;
  }
  // 页面加载后
  Router.prototype.afterEach = function() {
    var _this = this;
    var _a;
    if (!((_a = this._router) === null || _a === void 0 ? void 0 : _a.afterEach)) {
      console.error('仅支持vue页面！');
      return false;
    }
    // 路由前置钩子
    this._router.beforeEach(function(to, from, next) {
      // /* 统计页面停留时间 */
      // if (from.matched.length) {
      //     Object.assign(this.routerPage, {
      //         url: `${window.location.origin}/#${from.path}`,
      //         urlPath: from.path,
      //         referrerUrl: this.routerPage.referrerUrl,
      //         referrerHost: this.routerPage.referrerHost,
      //         eventDuration: 0
      //     })
      //     const delayTime = new Date().getTime()
      //     this.routerPage.eventDuration = delayTime - this.currentTime;
      //     this.currentTime = delayTime;
      //     this.send(this.routerPage)
      // }
      next();
    });
    // 路由后置钩子
    this._router.afterEach(function(to, from) {
      Object.assign(_this.routerPage, {
        url: ''.concat(window.location.origin, '/#').concat(to.path),
        urlPath: to.path,
        referrerUrl: from.path,
        referrerHost: window.location.host,
        eventDuration: 0
      });
      _this.send(_this.routerPage);
    });
  };
  return Router;
}(Basic));

function init(_a) {
  var appId = _a.appId; _a.name; var router = _a.router; var sendUrl = _a.sendUrl; var config = _a.config;
  new Event(appId, sendUrl, config);
  new Router(appId, router, sendUrl, config);
}
window.htWebPoints = init;

export { init };
